

















































































































































































































































































































































































































import Confirmacao from '@/components/ui/Confirmacao.vue'
import { PreVenda, PreVendaListagem } from '@/models/pre-venda/PreVenda'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import { ImportarPreVendaUseCase } from '@/usecases'
import { PreVendaUseCase } from '@/usecases/venda/PreVendaUseCase'
import { Component, Watch, Ref, Prop, PropSync } from 'vue-property-decorator'
import SeletorDeCliente from '../clientes/SeletorDeCliente.vue'
import { Cliente, TabelaDePreco } from '@/models'
import Vue from "vue"
import VueQuagga from "vue-quaggajs"
Vue.use(VueQuagga);

@Component({
	components: {
		Confirmacao,
		SeletorDeCliente,
	},
})
export default class DialogoDeImportarPreVenda extends Vue {
	@PropSync('mostra', { type: Boolean, default: false }) syncMostra!: boolean
	@Prop({ type: Boolean }) telaDeEmissaoDeNota!: boolean
	@Ref() form!: HTMLFormElement
	@Ref("confirmacao") confirmacao!: Confirmacao
	@Prop({ type: Object }) tabelaDePrecoSelecionada!: TabelaDePreco | null

	dateTimeToPtBrFormat = dateTimeToPtBrFormat

	preVendas: PreVendaListagem[] = []
	loading = false
	identificador = ''
	importarPreVendaUseCase = new ImportarPreVendaUseCase()
	preVendaUseCase = new PreVendaUseCase()
	carregando = false
	filtro: FiltroDePreVenda = {
		cliente: null,
		identificador: '',
		tipoDePreVenda: null,
	}

	opcoesDeModalidade = [
		{ label: 'Venda', value: 'venda' },
		{ label: 'Demonstração', value: 'demonstracao' },
		{ label: 'Consignação', value: 'consignacao' },
		{ label: 'Brinde', value: 'brinde' },
		{ label: 'Outras entradas', value: 'outras entradas' },
		{ label: 'Outras saídas', value: 'outras saidas' },
		{ label: 'Conserto', value: 'conserto' },
		{ label: 'Ativo', value: 'ativo' },
		{ label: 'Devolução entrada', value: 'devolucao entrada' },
		{ label: 'Devolução saída', value: 'devolucao saida' },
		{ label: 'Atacado', value: 'atacado' },
	]
	mostrarDetalhes = false
	preVendaSelecionada: PreVendaListagem | null = null
	preVendaDetalhada: PreVenda | null = null
	carregandoDetalhes = false

	mostrarDialogoLeituraDeCodigoBarras = false
	showCamera = false
	buscandoIdentificador = false

	readerSize = {
		width: 860,
		height: 480,
	}

	get lojaId() {
		return this.telaDeEmissaoDeNota 
			? VendaModule.lojaDaEntrada?.id
			: VendaModule.lojaDaVenda?.id
	}

	@Watch('syncMostra', { immediate: true })
	async buscarPreVenda() {

		if(!this.syncMostra) return
		this.loading = true

		const params = {
			situacoes: 'Aberto',
			lojaId: this.lojaId,
			cpfOuCnpjCliente: this.filtro.cliente != null ? this.filtro.cliente.cnpjOuCpf : undefined,
			identificador: this.filtro.identificador != '' ? this.filtro.identificador : undefined,
			tipoDePreVenda: this.filtro.tipoDePreVenda ?? undefined,
		}

		try {
			const lista = await this.preVendaUseCase.findPreVendaListagem(params)
			const toTime = (d?: Date |string | null) => (d ? new Date(d).getTime() : 0);
			this.preVendas = lista.slice().sort((a, b) => toTime(b.dataHoraCriacao) - toTime(a.dataHoraCriacao));
			this.loading = false
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	fechar(){
		this.syncMostra = false
		this.filtro = {
			cliente: null,
			identificador: '',
			tipoDePreVenda: null,
		}
	}

	async importarPreVenda(PreVendaListagem: PreVendaListagem) {
		try {
			this.loading = true 
			const resultado = await this.importarPreVendaUseCase.importarPreVenda(PreVendaListagem.identificador, this.telaDeEmissaoDeNota, this.tabelaDePrecoSelecionada)
			
			this.$emit('preVendaImportada', resultado)
			this.fechar()
		} catch(e) {
			AlertModule.setError(e)
		} finally {
			this.loading = false
		}
	}

	limparFiltros() {
		this.filtro = {
			cliente: null,
			identificador: '',
			tipoDePreVenda: null,
		}

		this.buscarPreVenda()
	}

	get totalQuantidade(): number {
		return this.preVendaDetalhada?.itens.reduce((acc, item) => acc + item.quantidade, 0) ?? 0
	}

	get totalValor(): number {
		return this.preVendaDetalhada?.itens.reduce((acc, item) => acc + item.quantidade * item.preco, 0) ?? 0
	}

	formatCurrency(value: number): string {
		return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
	}

	async abrirDetalhes(preVenda: PreVendaListagem) {
		this.preVendaSelecionada = preVenda
		this.preVendaDetalhada = null
		this.mostrarDetalhes = true
		this.carregandoDetalhes = true
		try {
			this.preVendaDetalhada = await this.preVendaUseCase.findPreVendaByIdentificador(preVenda.identificador)
		} catch(e) {
			AlertModule.setError(e)
			this.mostrarDetalhes = false
		} finally {
			this.carregandoDetalhes = false
		}
	}

	fecharDetalhes() {
		this.mostrarDetalhes = false
		this.preVendaSelecionada = null
		this.preVendaDetalhada = null
	}

	async importarPreVendaSelecionada() {
		if (!this.preVendaSelecionada) return
		await this.importarPreVenda(this.preVendaSelecionada)
		this.fecharDetalhes()
	}

	labelDaModalidade(tipo: PreVenda['tipoDePreVenda'] | null | undefined): string {
		return this.opcoesDeModalidade.find(o => o.value === tipo)?.label ?? '—'
	}

	corDaModalidade(tipo: PreVenda['tipoDePreVenda'] | null | undefined): string {
		const cores: Record<string, string> = {
			'venda': 'primary',
			'demonstracao': 'orange darken-1',
			'consignacao': 'purple darken-1',
			'brinde': 'pink darken-1',
			'outras entradas': 'teal darken-1',
			'outras saidas': 'brown darken-1',
			'conserto': 'amber darken-2',
			'ativo': 'blue darken-2',
			'devolucao entrada': 'red lighten-1',
			'devolucao saida': 'deep-orange darken-1',
			'atacado': 'green darken-2',
		}
		return tipo ? (cores[tipo] ?? 'grey darken-1') : 'grey darken-1'
	}

	abrirLeitorDeCodigoDeBarras() {
		this.mostrarDialogoLeituraDeCodigoBarras = true
		this.showCamera = true
	}

	fecharLeitorDeCodigoDeBarras() {
		this.mostrarDialogoLeituraDeCodigoBarras = false
		this.showCamera = false
		this.buscandoIdentificador = false
	}

	async onBarcodeDetected(data: any) {
		this.showCamera = false
		this.buscandoIdentificador = true

		try {
			const codigoLido = data?.codeResult?.code

			if (!codigoLido) {
				throw new Error('Não foi possível ler o código de barras')
			}

			this.filtro.identificador = codigoLido

			await this.buscarPreVenda()

		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.buscandoIdentificador = false
			this.mostrarDialogoLeituraDeCodigoBarras = false
			this.showCamera = true
		}
	}
}

export interface FiltroDePreVenda {
	cliente: Cliente | null
	identificador: string | null
	tipoDePreVenda: PreVenda['tipoDePreVenda'] | null
}

